import React from 'react';
import './TabsContent.css';

class TabsContent extends React.Component {
  render() {
    const details = this.props.data

    return (
      <div className="tabs-content">
        <h2 className="tabs-content-title">{details.title}</h2>
        <h3 className="tabs-content-subtitle">{details.subtitle}</h3>
        <p className="tabs-content-description">{details.description}</p>
        { /* <a className="tabs-content-link">Read More</a> */ }
      </div>
    )
  }
}

export default TabsContent



// WEBPACK FOOTER //
// ./src/Shared/TabsContent.js